import { NullableBooleanInput, NullableBooleanInputProps } from 'react-admin';

/**
 * Custom React-admin `NullableBooleanInput` to be used as a list "status" filter input for filter
 * params like `deleted_at@_is_null` and `archived_at@_is_null`.
 */
const AuditBasedStatusFilterInput = (
  props: Omit<NullableBooleanInputProps, 'trueLabel' | 'falseLabel'> & {
    activeLabel?: string;
    inactiveLabel?: string;
  },
) => {
  const { activeLabel = 'Active', inactiveLabel = 'Deleted', ...rest } = props;

  return <NullableBooleanInput label="Status" trueLabel={activeLabel} falseLabel={inactiveLabel} {...rest} />;
};

export default AuditBasedStatusFilterInput;
